export enum EqualityOperator {
  None = 0,
  LessThan = 1,
  LessThanOrEqual = 2,
  Equal = 3,
  GreaterThanOrEqual = 4,
  GreaterThan = 5,
  NotEqual = 6
}

export const EqualityOperatorMapping: Record<EqualityOperator, string> = {
  [EqualityOperator.None]: 'None',
  [EqualityOperator.LessThan]: '<',
  [EqualityOperator.LessThanOrEqual]: '<=',
  [EqualityOperator.Equal]: '=',
  [EqualityOperator.GreaterThanOrEqual]: '>',
  [EqualityOperator.GreaterThan]: '>=',
  [EqualityOperator.NotEqual]: '<>'
};
